// extracted by mini-css-extract-plugin
export default {"wrapper":"WQtPH2xsYKBnqE39V3UZ","emptyStateWrapper":"dh5KTtkcdjXHN49JeKDA","pagination":"Qwsl6ZsJXpBet8ntw7rX"};